import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "@rekonas/auth";
import { AppShell } from "./components/AppShell";
import { LoginPage } from "./routes/LoginPage";
import { RecordingDetailPage } from "./routes/RecordingDetailPage";
import { DemoRecordingPage } from "./routes/DemoRecordingPage";
import { RecordingsPage } from "./routes/RecordingsPage";
import { AnalysisRunsPage } from "./routes/AnalysisRunsPage";
import { ReportImportPage } from "./routes/ReportImportPage";

import { WorkspaceAccessPage } from "./routes/WorkspaceAccessPage";

import { AiChatPage } from "./routes/AiChatPage";
import { MetricsContextsPage } from "./routes/MetricsContextsPage";
import { AiPromptsPage } from "./routes/AiPromptsPage";
import { OperationsPage, OperationsInspectionRoute } from "./routes/OperationsPage";
import { AccountSettingsPage } from "./routes/AccountSettingsPage";

function AuthenticatedLayout() {
  return <AppShell />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AuthenticatedLayout />}>
          <Route path="/recordings" element={<RecordingsPage />} />
          <Route path="/internal/operations" element={<OperationsInspectionRoute><OperationsPage /></OperationsInspectionRoute>} />
          <Route path="/account/settings" element={<AccountSettingsPage />} />
          <Route path="/recordings-demo" element={<DemoRecordingPage />} />
          <Route path="/recordings/:workspaceRef/:recordingRef" element={<RecordingDetailPage />} />
          <Route path="/internal/metrics-contexts" element={<OperationsInspectionRoute><MetricsContextsPage /></OperationsInspectionRoute>} />
          <Route path="/internal/ai-chat" element={<OperationsInspectionRoute><AiChatPage /></OperationsInspectionRoute>} />
          <Route path="/internal/ai-prompts" element={<AiPromptsPage />} />
          <Route path="/internal/workspace-access" element={<WorkspaceAccessPage />} />
          <Route path="/internal/analysis-runs" element={<OperationsInspectionRoute><AnalysisRunsPage /></OperationsInspectionRoute>} />
          <Route path="/internal/report-import" element={<ReportImportPage />} />
          <Route path="/" element={<Navigate to="/recordings" replace />} />
          <Route path="*" element={<Navigate to="/recordings" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
